import React from 'react';
function LineBreak() {
  return /*#__PURE__*/React.createElement("br", null);
}
LineBreak.displayName = 'LineBreak';
export default LineBreak;
//# sourceMappingURL=index.js.map